import Card from "./card";
import CheckBadge from "./check-badge";
import PrimaryButton from "./primary-button";
import Timeline from "./timeline";
import { UTILITY_STEPS, formatMoney } from "./utilities-config";

export default function PowerDone({ earn, homeAmount, onContinue, onFinish }) {
  return (
    <Card
      steps={UTILITY_STEPS}
      activeStep={0}
      progress={100}
      footer={
        <>
          <PrimaryButton onClick={onContinue}>Earn up to {formatMoney(homeAmount)} more</PrimaryButton>
          <button className="su-link" type="button" onClick={onFinish}>
            Go to my account
          </button>
        </>
      }
    >
      <div className="su-status">
        <CheckBadge />
        <h2 className="su-title">
          Power setup is complete.
          <span className="su-title-accent">{formatMoney(earn)} Cash Back is on the way.</span>
        </h2>
        <p className="su-subtitle">
          Your lights work the day you walk in.
          <br />
          Your Cash Back lands once you pay your first bill.
        </p>
        <Timeline
          items={[
            { when: "Today", title: "Order in", body: "Your part is done.", done: true },
            { when: "Move-in", title: "Power on", body: "Your lights work the day you walk in. Nothing to install." },
            { when: "First bill", title: `${formatMoney(earn)} Cash Back`, body: "We send it over once your first bill is paid." },
          ]}
        />
      </div>
    </Card>
  );
}
